import { Card, GridLegacy, MenuItem } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import TranslationWrapper, { getTranslation } from "../../../../components/TranslationWrapper/TranslationWrapper.tsx";
import CardBody from "../../../../components/Card/CardBody";
import { convertArrayToSelectOptions, convertObjectToSelectOptions } from "../../../../templateHelpers";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import FormControlledInputTC from "../../../../components/Forms/FormControlledInputTC";
import FormSelectTC from "../../../../components/Forms/FormSelectTC";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import { sortModes } from "../../../../variables/app";
import axios from "axios";
import { useController, useWatch } from "react-hook-form";
import MenuSyncSettings from "../MenuSyncSettings";
import FormAsyncTC from "../../../../components/Forms/FormAsyncTC";

function MplusAPI() {
  const apiMethod = useMemo(
    () => [
      { value: "TABLE", label: "Tafel orders" },
      { value: "ORDER", label: "Reguliere orders" },
    ],
    []
  );

  const apiMethodOptions = useMemo(() => convertObjectToSelectOptions(apiMethod), []);
  const sortModeList = useMemo(() => convertArrayToSelectOptions(sortModes), []);

  const [fieldsformapping, setFieldsformapping] = useState(null);

  const {
    field: { value: sendTerminalMplusOrders, onChange: sendTerminalMplusOrdersOnChange },
  } = useController({ name: "apiaccounts__sendTerminalMplusOrders" });

  useEffect(() => {
    axios.get("core/fieldsformapping").then((response) => {
      setFieldsformapping(response.data.data.data);
    });
  }, []);
  const syncVersion = useWatch({ name: "custom_data.mplus.sync_version" }, "V1");
  const vestigingId = useWatch({ name: "id" });
  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card style={{ marginBottom: "16px" }}>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper tDefault={"MplusKASSA"} tKey={"vestigingen.form.mpluskassa.headers.mpluskassa"} />
              </h3>
              <h4>
                <TranslationWrapper
                  tDefault={"Connection Settings"}
                  tKey={"vestigingen.form.mplus.headers.connectionSettings"}
                />
              </h4>
            </GridLegacy>
            <FormTextTC name={"mplusServer"} tDefault={"Server"} tKey={"vestigingen.form.mplusapi.label.mplusServer"} />
            <FormControlledInputTC
              default={"Port"}
              name={"mplusPort"}
              rules={{
                max: { value: 65535, message: getTranslation("The maximum value is 65535!") },
                min: { value: 1, message: getTranslation("The minimum value is 1!") },
                required: { value: true, message: getTranslation("This field is required!") },
              }}
              tKey={"vestigingen.form.mplusapi.label.mplusPort"}
              type={"number"}
            />
            <FormTextTC
              name={"mplusApiIdent"}
              tDefault={"API Ident"}
              tKey={"vestigingen.form.mplusapi.label.mplusApiIdent"}
            />
            <FormTextTC
              name={"mplusApiSecret"}
              tDefault={"API Secret"}
              tKey={"vestigingen.form.mplusapi.label.mplusApiSecret"}
            />
            <FormTextTC
              name={"mplusWebhookSecret"}
              tDefault={"Webhook Secret"}
              tKey={"vestigingen.form.mplusapi.label.mplusWebHookSecret"}
            />
            <FormAsyncTC
              async={{ url: `core/pos-api/mplus/getBranches?vid=${vestigingId}` }}
              name={"mplusBranch"}
              tDefault={"Branch"}
              tKey={"vestigingen.form.mplusapi.label.mplusBranch"}
            />
            <FormAsyncTC
              async={{ url: `core/pos-api/mplus/getAvailableTerminalList?vid=${vestigingId}` }}
              name={"mplusTerm"}
              tDefault={"Terminal"}
              tKey={"vestigingen.form.mplusapi.label.mplusTerm"}
            />
            <FormSwitchTC
              disabled={sendTerminalMplusOrders}
              name={"apiaccounts__sendTerminalMplusOrders"}
              tDefault={"Sent terminal on orders"}
              tKey={"vestigingen.form.mplusapi.label.sendTerminalMplusOrders"}
            />
            <FormTextTC
              name={"hardwareIdentifier"}
              tDefault={"Hardware ID (BB)"}
              tKey={"vestigingen.form.mplusapi.label.hardwareIdentifier"}
            />
            <FormSelectTC
              defaultValue={"V1"}
              name={"custom_data.mplus.sync_version"}
              options={[<MenuItem value={"V1"}>V1</MenuItem>, <MenuItem value={"V2"}>V2</MenuItem>]}
              tDefault={"Jamezz Sync Version"}
              tKey={"custom_data.mplus.sync_version"}
            />
            <FormSwitchTC
              defaultValue={false}
              name={"custom_data.pos.send_pager_as_ordernumber"}
              tKey={"Send pagernumber as order number"}
            />

            {syncVersion == "V2" ? <MenuSyncSettings /> : null}
          </GridLegacy>
        </CardBody>
      </Card>
      <Card style={{ marginBottom: "16px" }}>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridLegacy item xs={12}>
            <h3>
              <TranslationWrapper tDefault={"POS Settings"} tKey={"vestigingen.form.mpluskassa.headers.possettings"} />
            </h3>
          </GridLegacy>
        </CardBody>
      </Card>
      <Card style={{ marginBottom: "16px" }}>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <FormSelectTC
              name={"mplusApiMethod"}
              options={apiMethodOptions}
              tDefault={"Order method"}
              tKey={"vestigingen.form.mplusapi.label.mplusApiMethod"}
            />
            <FormAsyncTC
              async={{ url: `core/pos-api/mplus/getRelations?vid=${vestigingId}` }}
              name={"mplusZuilRel"}
              tDefault={"Zuil relatie"}
              tKey={"vestigingen.form.mplusapi.label.mplusZuilRel"}
            />
            <FormTextTC
              name={"mplusPrijsGroup"}
              tDefault={"Prijs groep"}
              tKey={"vestigingen.form.mplusapi.label.mplusPrijsGroup"}
            />
            <FormAsyncTC
              async={{ url: `core/pos-api/mplus/getEmployees?vid=${vestigingId}` }}
              name={"mplusEmployeeNr"}
              tDefault={"Employee number"}
              tKey={"vestigingen.form.mplusapi.label.mplusEmployeeNr"}
            />
            {syncVersion != "V2" ? (
              <>
                <FormSwitchTC
                  name={"mplusautosync"}
                  tDefault={"Auto sync"}
                  tKey={"vestigingen.form.mplusapi.label.mplusautosync"}
                />
                <FormTextTC
                  name={"mplusServiceBill"}
                  tDefault={"Rekening (service)"}
                  tKey={"vestigingen.form.mplusapi.label.mplusServiceBill"}
                />
                <FormTextTC
                  name={"mplusServiceTable"}
                  tDefault={"Bediening (service)"}
                  tKey={"vestigingen.form.mplusapi.label.mplusServiceTable"}
                />
                <FormTextTC
                  name={"mplusAnr1"}
                  tDefault={"Artikel # meenemen"}
                  tKey={"vestigingen.form.mplusapi.label.mplusAnr1"}
                />
                <FormTextTC
                  name={"mplusAnr2"}
                  tDefault={"Artikel # hier opeten"}
                  tKey={"vestigingen.form.mplusapi.label.mplusAnr2"}
                />
              </>
            ) : null}
            <FormAsyncTC
              async={{ url: `core/pos-api/mplus/getPaymentMethods?vid=${vestigingId}` }}
              name={"mplusPaymethod"}
              tDefault={"Betaalwijze"}
              tKey={"vestigingen.form.mplusapi.label.mplusPaymethod"}
            />
            <FormTextTC
              name={"mplusSubLocation"}
              tDefault={"Sub locatie"}
              tKey={"vestigingen.form.mplusapi.label.mplusSubLocation"}
            />
            <FormSwitchTC
              name={"mplusSComments"}
              tDefault={"Comments"}
              tKey={"vestigingen.form.mplusapi.label.mplusSComments"}
            />
            <FormSwitchTC
              name={"mplusOCnt"}
              tDefault={"Send OCnt"}
              tKey={"vestigingen.form.mplusapi.label.mplusOCnt"}
            />
            <FormSwitchTC
              name={"mplusEatinTakeaway"}
              tDefault={"eatin/takeaway"}
              tKey={"vestigingen.form.mplusapi.label.mplusEatinTakeaway"}
            />
            <FormSwitchTC
              name={"mplusPrePay"}
              tDefault={"Prepaid flag"}
              tKey={"vestigingen.form.mplusapi.label.mplusPrePay"}
            />
            <FormSwitchTC
              name={"mplusNOS"}
              tDefault={"Skip option sync"}
              tKey={"vestigingen.form.mplusapi.label.mplusNOS"}
            />
            <FormSwitchTC
              name={"mplusSyncSubGroups"}
              tDefault={"Copy subgroups from POS"}
              tKey={"vestigingen.form.mplusapi.label.mplusSyncSubGroups"}
            />
            <FormAsyncTC
              async={{ url: `core/pos-api/mplus/getDeliveryMethods?vid=${vestigingId}` }}
              name={"mplusAfhalen"}
              tDefault={"Afhalen"}
              tKey={"vestigingen.form.mplusapi.label.mplusAfhalen"}
            />
            <FormAsyncTC
              async={{ url: `core/pos-api/mplus/getDeliveryMethods?vid=${vestigingId}` }}
              name={"mplusBezorgen"}
              tDefault={"Bezorgen"}
              tKey={"vestigingen.form.mplusapi.label.mplusBezorgen"}
            />
            <FormAsyncTC
              async={{ url: `core/pos-api/mplus/getDeliveryMethods?vid=${vestigingId}` }}
              name={"mplusHierOpeten"}
              tDefault={"Hier opeten"}
              tKey={"vestigingen.form.mplusapi.label.mplusHierOpeten"}
            />
            <FormTextTC
              name={"mplusOpmerkingProduct"}
              tDefault={"Opmerking product"}
              tKey={"vestigingen.form.mplusapi.label.mplusOpmerkingProduct"}
            />
            {syncVersion == "V1" ? (
              <FormSelectTC
                name={"extra_settings__optionSortMode"}
                options={sortModeList}
                tDefault={"Option sortmode"}
                tKey={"vestigingen.form.overige.label.sortModes"}
              />
            ) : null}
            <FormSwitchTC
              name={"useWithoutTableOverlappingMiddleware"}
              tDefault={"Don't overlap table request"}
              tKey={"vestigingen.form.overige.label.useWithoutTableOverlappingMiddleware"}
            />
            <FormSwitchTC
              name={"extra_settings__composed_product_as_option"}
              tDefault={"Composed product as options"}
              tKey={"vestigingen.form.algemeen.label.composedProductAsOption"}
            />{" "}
            <FormSwitchTC
              name={"extra_settings__send_payment_info_as_comment"}
              tDefault={"Send payment method as comment"}
              tKey={"vestigingen.form.algemeen.label.send_payment_info_as_comment"}
            />
            <FormSwitchTC
              name={"sendPrice"}
              tDefault={"Send price to API"}
              tKey={"vestigingen.form.algemeen.label.sendPrice"}
            />
            <FormSwitchTC name={"multibtw"} tDefault={"Multi VAT"} tKey={"vestigingen.form.algemeen.label.multibtw"} />
            {/*    <FormSwitchTC
              name={"useMplusApiV2"}
              tKey={"vestigingen.form.algemeen.label.useMplusApiV2"}
              tDefault={"Use mplus api v2"}
            /> */}
          </GridLegacy>
        </CardBody>
      </Card>
      <Card style={{ marginBottom: "16px" }}>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridLegacy item xs={12}>
            <h3>
              <TranslationWrapper
                tDefault={"Custom field-mappings"}
                tKey={"vestigingen.form.mpluskassa.headers.customfieldmappings"}
              />
            </h3>
          </GridLegacy>
          {fieldsformapping?.map((mapping) => {
            let dbkey = "mpluscustomfieldsmap_" + mapping.mapfield;

            return <FormTextTC key={mapping.mapfield} name={dbkey} tKey={mapping.mapfield} />;
          })}
        </CardBody>
      </Card>
    </div>
  );
}

export default MplusAPI;
